<template>
  <div>
    <div class="page-container">
      <div class="page-title"><img src="~@/assets/image/icons/book.png" alt=""> 自助提領指南</div>
      <div class="page-content">
        <div>
          <div class="page-left">1</div>
          <div class="page-right">
            <p>在<span @click="jumpWithdraw">nicee自助提領頁面</span>發起提領（首次自助提領需要創建帳戶）</p>
          </div>
        </div>
        <div>
          <div class="page-left">2</div>
          <div class="page-right">
            <p>查看nicee綁定的手機號碼或郵箱，收到初始帳號和密碼後，訪問<a href="https://www.newebpay.com/">藍新金流官網</a>，並使</p>
            <p>用收到的帳戶密碼登入。</p>
            <h3>(請好好保存帳號和密碼，還可以將初始密碼修改為您的常用密碼喔～)</h3>
            <div class="houseofhello"></div>
          </div>
        </div>
        <div>
          <div class="page-left">3</div>
          <div class="page-right">
            <p>點擊“會員中心-基本資料設定-藍新金流帳戶”，查看待提領金額</p>
            <h3>(該金額由nicee自助提領頁面轉入，通常1~2個工作日到帳)</h3>
            <div class="atm-step-1">
              <img src="~@/assets/image/background/atm-step-2.png" alt="">
            </div>
          </div>
        </div>
        <div>
          <div class="page-left">4</div>
          <div class="page-right">
            <p>待提領金額到帳後，輸入金額和受款金融機構，可發起提領</p>
            <h3>(如受款金融機構帳號無法選擇，有可能是因為首次創建帳戶，銀行審核時間較長，通常為3-4天，請</h3>
            <h3>耐心等候。點擊貼心提醒中的「金融機構帳號設定」可查看審核進度。)</h3>
            <div class="atm-step-2">
              <img src="~@/assets/image/background/atm-step-3.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'withdrawGuide',
  methods:{
    jumpWithdraw(){
      this.$router.push('/withdraw')
    }
  }
}
</script>
<style lang="scss" scoped>
  .page-container {
    background: #fff;
    margin: 40px auto;
    padding-bottom: 80px;
    >div{
      padding-left: 40px;
    }
    .page-title {
      display: flex;
      align-items: center;
      border-bottom: 1px solid $color-button;
      height: 92px;
      img{
        width: 18px;
        height: 22px;
        margin-right: 7px;
      }
    }
    .page-content{
      >div{
        display: flex;
        margin-top: 56px;
      }
      >div:nth-of-type(1){
        margin-top: 36px;
      }
    }
  }
  .page-left{
      font-weight: 300;
      font-size: 40px;
      line-height: 40px;
      text-align: center;
      letter-spacing: -0.000319808px;
      color: #222C43;
    }
    .page-right{
      margin-left: 24px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      p{
        font-size: 14px;
        line-height: 20px;
        color: #222C43;
        span,a{
          color: #4987F5;
          cursor: pointer;
        }
      }
      h3{
        font-size: 14px;
        line-height: 20px;
        color: #636D86;
        margin-top: 8px;
        font-weight: normal;
      }
    }
    .houseofhello{
      width: 367px;
      height: 216px;
      margin-top: 20px;
      background: url('~@/assets/image/background/atm-step-1.png') no-repeat center center / 100%;
    }
    .atm-step-1{
      width: 673px;
      height: 342px;
      img{
        width: 633px;
      }
      img:nth-of-type(1){
        height: 302px;
      }
      img:nth-of-type(2){
        height: 161px;
        margin-top: 12px;
      }
    }
    .atm-step-2{
      width: 530px;
      height: 403px;
      img{
        width: 490px;
        height: 363px;
      }
    }
    .atm-step-1,.atm-step-2{
      background: #F5F5F5;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
    }
</style>
